import AccordionBasic from '@material-ui/core/Accordion';
import AccordionSummaryBasic from '@material-ui/core/AccordionSummary';
import AccordionDetailsBasic from '@material-ui/core/AccordionDetails';
import { withStyles } from '@material-ui/core/styles';


const accordion = {
  root: {
    justifyContent: 'flex-end !important',
    border: '0px',
    boxShadow: 'none',
    marginTop:'0px !important',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
    
    },
    '&$expanded': {

    },
    // maxWidth:'200px !important',
    // minWidth:'200px !important'
  },
}

const Accordion = withStyles(accordion)(AccordionBasic);

const accordionSummary = {
  root:{
    color: '#0088CF',
    minHeight:'20px',
    maxHeight:'20px',
    flexDirection: 'row-reverse !important',
    // padding:'0px',
    paddingLeft: '0px !important',
    justifyContent: 'flex-end !important',
    
  },
  content:{
    minWidth:'200px !important',
    maxWidth:'200px !important'
  },
  expanded: {
    minHeight:'20px !important',
    maxHeight:'20px !important',
  },
  expandIcon:{
    position: 'relative !important',
    transform: 'rotate(-90deg)',
    '&$expanded': {
      transform: 'rotate(0deg)',
    },
    
  }
}
export const AccordionSummary = withStyles(accordionSummary)(AccordionSummaryBasic);

const accordionDetails = {
    root:{
     flexDirection:'column !important'
    }
}

export const AccordionDetails = withStyles(accordionDetails)(AccordionDetailsBasic);

export default Accordion;